export default "__VITE_ASSET__CtG0OnBm__"